/**
 * The "this control is currently doing something" fill for top-bar buttons —
 * an open menu, the active History view, a chevron mid-press.
 *
 * Its own module because the three surfaces that need it (the toolbar, the
 * incognito toggle, the nav chevrons) sit in different files with no other
 * reason to import each other, and a fourth copy would drift before anyone
 * noticed. Incognito's *on* state is deliberately not this — it's a success
 * tint, because it reports a mode rather than a pressed control.
 */
export const ACTIVE_TOOLBAR_BUTTON_CLASS = 'bg-element-active border'
